<template>
  <div class="search-page" v-cloak>
    <!-- 搜索栏 -->
    <div class="header-searchd">
      <div class="left-icon" @click="onClickLeft">
        <van-icon size="19" name="arrow-left" />
      </div>
      <div class="searchd" @click="goSearch">{{ key }}</div>
      <div class="header-icon" @click="onClickRight()">
        <img class="i-c" src="../../assets/public/car_icon.png" alt="" />
      </div>
    </div>

    <!-- 吸顶tabs -->
    <van-sticky :offset-top="45" :z-index="4002">
      <div class="table-block">
        <!-- 筛选tabs -->
        <div class="l-table">
          <div :class="['tbs-item', tabInd == index ? 'tbs-item-active' : '']" v-for="(item, index) in tabsList" :key="index" @click="onTabs(index)">
            {{ item }}
            <!-- <div v-if="index == 1" :class="[ 'tabs-arrow ',  ordinal == 'asc' ? 'arrow-up' : 'arrow-down', ]"></div> -->
            <div v-if="index == 1" :class="[ 'tabs-arrow ', tabInd != index ? 'arrow-u-d' :  ordinal == 'asc' ? 'arrow-up' : 'arrow-down', ]"></div>
          </div>
        </div>
        <div class="r-btn" @click="onShowType">
          <img v-if="showType == 'column'" src="../../assets/public/row_icon.png" alt="" />
          <img v-else src="../../assets/public/column_icon.png" alt="" />
        </div>
      </div>
    </van-sticky>
    <!-- 排序 -->
    <!-- <van-popup v-model="isOrdinal" position="top" :style="{top:'89px' }">
      <h3 class="pop-tips"> <span class="in-text">商品价格</span> </h3>

      <div class="pop-ordinal-block">
        <van-cell title="从小到大" @click="getOrdinal('asc')">
            //asc: 从小到大，desc:从大到小 
          <template #right-icon>
            <van-icon name="checked" v-if="ordinal == 'asc'" color="#ff510093" />
            <van-icon name="checked" v-else color="#E2E8ED" />
          </template>
        </van-cell>
        <van-cell title="从大到小" @click="getOrdinal('desc')">
          <template #right-icon>
            <van-icon name="checked" v-if="ordinal == 'desc'" color="#ff510093" />
            <van-icon name="checked" v-else color="#E2E8ED" />
          </template>
        </van-cell>
      </div>
    </van-popup> -->

    <!-- 价格区间 -->
    <van-popup v-model="isMoney" position="top" :style="{top:'89px' }">
      <h3 class="pop-tips"> <span class="in-text">价格区间</span> </h3>
      <!-- 允许输入数字，调起带符号的纯数字键盘 -->
      <van-field v-model="beginPrice" type="number" label="最小价格" placeholder="请输入最小价格" clearable />
      <!-- 允许输入数字，调起带符号的纯数字键盘 -->
      <van-field v-model="endPrice" type="number" label="最大价格" placeholder="请输入最大价格" clearable />

      <div class="btn-block">
        <div class="btn-left btnC" @click="cancelPrice()">取消筛选</div>
        <div class="btn-right btnC" @click="getPrice()">确定筛选</div>
      </div>
    </van-popup>

    <!-- 列表 -->
    <div class="list">
      <van-list style="display: flex; flex-wrap:wrap;" v-model="loading" :finished="finished" finished-text="没有更多了" @load="getProductList">
        <img-text-block :show-type="showType" :product="item" v-for="(item, index) in productList" :key="index"></img-text-block>
      </van-list>

      <van-empty class="custom-image" v-if="productList.length< 1" image="https://qiniu.zdyxjx.com/v3/pic/9e01608b529549fe87e021683c1e8d15.png" />

      <!-- 热门搜索 -->
      <div class="hot-block">
        <div class="tips-block">
          <span class="tips-title">热门搜索</span>
          <div class="tips-icon" @click="onHot">
            <van-icon v-if="isHot" name="eye-o" />
            <van-icon v-else name="closed-eye" />
          </div>
        </div>
        <!-- 模块  -->
        <div class="lable-block" v-show="isHot">
          <van-tag class="mlt" v-for="(item, index) in hotList" :key="index" size="large" color="#F9F9F9" text-color="#999999" type="primary" @click="goSearchInput(item)">{{ item }}</van-tag>
        </div>
      </div>
    </div>

  </div>
</template>

<script type="text/babel">
import imgTextBlock from "@/components/img-text-block/img-text-block.vue";
var isBack = true;
export default {
  beforeRouteEnter(to, from, next) {
    if (from.path == "/product-details") {
      isBack = true;
    } else {
      isBack = false;
    }
    next();
  },
  name: "search-list",
  components: { imgTextBlock },
  props: {},
  data() {
    return {
      isFirstEnter: false, // 是否第一次进入，默认false

      showType: "column",
      key: this.$route.query.key,
      tabsList: ["综合", "价格", "筛选"],
      tabInd: 0,
      isHot: true, // 热门显示隐藏
      hotList: [
        "耳机",
        "包",
        "礼盒",
        "家居",
        "毛巾",
        "海鲜",
        "饮料",
        "洗护",
        "配件",
        "水杯",
        "水壶",
      ], //热门
      // isOrdinal: false,
      isMoney: false,

      productList: [], //商品
      pageNum: 1,
      pageSize: 20,
      loading: true,
      finished: false,

      orderBy: "",
      ordinal: "asc", //asc: 从小到大，desc:从大到小
      beginPrice: "",
      endPrice: "",
    };
  },
  watch: {
    // aa: {
    //   handler(newValue, oldValue) {
    //     console.log(newValue, oldValue);
    //   },
    //   deep: true, // 深度监听表单
    // },
  },
  created() {
    this.isFirstEnter = true;
  },
  activated() {
    if (!isBack || this.isFirstEnter) {
      this.productList = [];
      this.pageNum = 1;
      this.pageSize = 20;
      this.loading = true;
      this.finished = false;
      this.key = this.$route.query.key;
      this.getProductList();
      // console.log("刷新");
    }
    this.isFirstEnter = false;
  },
  mounted() {},
  methods: {
    getProductList() {
      let _this = this;
      let data = {
        sort: _this.ordinal == "asc" ? 1 : 2,
        min_price: _this.beginPrice,
        max_price: _this.endPrice,
        keyword: _this.key,
        page: _this.pageNum,
        limit: _this.pageSize,
      };
      _this.$post("/api/goods_list", data, data).then((res) => {
        // console.log(res.data);
        _this.loading = false; // 加载状态结束

        if (res.data.code == 0) {
          console.log(res.data.data);
          let lists = res.data.data;

          if (lists && lists.length > 0) {
            if (_this.pageNum == 1) {
              _this.productList = lists;
            } else {
              _this.productList = _this.productList.concat(lists);
            }
            _this.pageNum++;
            if (lists.length < _this.pageSize) {
              _this.finished = true; // 数据全部加载完成
            }
          } else {
            // console.log('444')
            _this.finished = true; // 数据全部加载完成
          }
        } else {
          // console.log('555')
          _this.$toast.fail(res.data.message);
          _this.finished = true;
        }
      });
    },
    // 热门搜索显示隐藏
    onHot() {
      this.isHot = !this.isHot;
    },
    // 点击标签
    goSearchInput(e) {
      // console.log(e)
      this.key = e;
      this.$route.query.key = e;
      Lockr.sadd("historyList", e); // 往缓存里添加
      // this.$router.push({ name:'search-list',  query:{key:e}});

      this.productList = [];
      this.pageNum = 1;
      this.loading = true;
      this.finished = false;
      this.getProductList();
    },
    // 切换tabs
    onTabs(ind) {
      this.tabInd = ind;
      if (ind == 0) {
        this.orderBy = "";

        this.isMoney = false;
        // this.isOrdinal = false;
        this.productList = [];
        this.pageNum = 1;
        this.loading = true;
        this.finished = false;
        this.getProductList();
      } else if (ind == 1) {
        this.orderBy = "price";
        this.ordinal = this.ordinal == "asc" ? "desc" : "asc";
        // this.isOrdinal = !this.isOrdinal;
        //asc: 从小到大，desc:从大到小
        this.isMoney = false;

        this.productList = [];
        this.pageNum = 1;
        this.loading = true;
        this.finished = false;
        this.getProductList();
      } else if (ind == 2) {
        this.orderBy = "price";
        this.isMoney = !this.isMoney;
        // this.isOrdinal = false;
      }
    },
    // 列表显示种类
    onShowType() {
      this.showType = this.showType == "column" ? "row" : "column";
    },
    // 去搜索
    goSearch() {
      this.$router.go(-1);
    },
    // 返回上一页
    onClickLeft() {
      this.$route.query.key = "";
      this.$router.go(-1);
    },
    onClickRight() {
      this.MakeCall(); //拨打电话
    },
    // 次序
    // getOrdinal(e) {
    //   this.ordinal = e;
    //   this.isOrdinal = false;

    //   this.productList = [];
    //   this.pageNum = 1;
    //   this.loading = true;
    //   this.finished = false;
    //   this.getProductList()
    // },
    // 确定价格筛选
    getPrice() {
      this.isMoney = false;

      this.productList = [];
      this.pageNum = 1;
      this.loading = true;
      this.finished = false;
      this.getProductList();
    },
    // 取消价格筛选
    cancelPrice() {
      this.isMoney = false;
      this.beginPrice = "";
      this.endPrice = "";

      this.productList = [];
      this.pageNum = 1;
      this.loading = true;
      this.finished = false;
      this.getProductList();
    },
  },
};
</script>

<style lang="scss">
.search-page {
  // 空状态
  .custom-image .van-empty__image {
    width: 260px;
    height: 300px;
  }
}
</style>

<style lang="scss" scoped>
.search-page {
  height: 100%;
  width: 100%;
  padding-top: 44px;
  background-color: #f9f9f9;

  // -webkit-overflow-scrolling: touch;
  // overflow-x: hidden;
  // overflow-y: scroll;
  // -ms-overflow-style: none; /* IE */
  // scrollbar-width: none; /* Firefox */

  //  顶部
  .header-searchd {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3002;
    height: 45px;
    width: 100%;
    padding: 7px 15px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;

    box-shadow: 0px 2.5px 3px rgba(120, 132, 158, 0.16);
    .searchd {
      // box-sizing: border-box;
      width: 285px;
      height: 100%;
      background-color: #e2e8ed;
      border-radius: 15px;
      font-size: 12px;
      padding: 0 15px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 30px;
      color: #78849e;
      text-align: left;
      white-space: nowrap;
      /*内容超宽后禁止换行显示*/
      overflow: hidden;
      /*超出部分隐藏*/
      text-overflow: ellipsis;
      /*文字超出部分以省略号显示*/
    }
    .left-icon {
      display: flex;
      align-items: center;
    }
    .header-icon {
      width: 20px;
      height: 100%;
      display: flex;
      align-items: center;
      .i-c {
        display: inline-block;
        width: 20px;
        height: 20px;
      }
    }
  }

  .table-block {
    width: 100%;
    height: 44px;
    z-index: 2002;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    box-shadow: 0px 2px 5px rgba(69, 79, 99, 0.08);

    .l-table {
      flex: 1;
      // width:325px;
      height: 100%;
      color: #78849e;
      font-size: 16px;
      overflow: hidden;
      padding-left: 10px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;

      .tbs-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 18px;

        .tabs-arrow {
          width: 7px;
          height: 11px;
          margin-left: 5px;

          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: 0 0;
        }
        .arrow-u-d {
          background-image: url("../../assets/public/arrow-u-d.png");
        }
        .arrow-up {
          background-image: url("../../assets/public/arrow-up.png");
        }
        .arrow-down {
          background-image: url("../../assets/public/arrow-down.png");
        }
      }
      .tbs-item-active {
        color: #ff5000;
      }
    }
    .r-btn {
      border-left: 1px solid #cccccc;
      width: 50px;
      height: 25px;
      margin-left: 10px;
      // background-color: palegreen;
      img {
        display: block;
        width: 20px;
        height: 20px;
        margin: 2.5px auto;
      }
    }
  }

  .list {
    // width: 100%;
    // height: 100%;
    padding: 5px 0 0;
    box-sizing: border-box;
    // overflow: hidden;
  }
  .hot-block {
    margin-bottom: 40px;
    // background-color: paleturquoise;
    // 模块标题
    .tips-block {
      width: 100%;
      height: 36px;
      padding: 0 18px;
      // background-color: #eee;
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .tips-title {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 27px;
        color: #454f63;
        letter-spacing: 2px;
      }
      .tips-icon {
        width: 15px;
        height: 15px;
        font-size: 15px;
        // background-color: palegreen;
      }
    }
    .tips-block::after {
      content: "";
      position: absolute;
      width: 3px;
      height: 13px;
      left: 0;
      top: 11px;
      background: #ff5000;
      z-index: 1;
      border-radius: 0 5px 5px 0;
    }
    // lable模块
    .lable-block {
      width: 100%;
      padding: 0 15px 15px 0;
      background-color: #fff;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      position: relative;
      .mlt {
        margin: 15px 0 0 15px;
      }
    }
  }
}

.pop-tips {
  text-align: left;
  padding: 0 10px;
  position: relative;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 27px;
  color: #454f63;
  letter-spacing: 1px;
  .in-text::after {
    content: "";
    position: absolute;
    width: 3px;
    height: 13px;
    left: 0;
    top: 8px;
    background: #ff5000;
    z-index: 1;
    border-radius: 0 10px 10px 0;
  }
}
.btn-block {
  // position: absolute;
  // bottom: 10px;
  // left: 0;
  margin-top: 25px;
  width: 100%;
  height: 47px;
  padding: 0 15px;
  background-color: #ffffff;
  border-top: 1px solid #f9f9f9;

  box-shadow: 0px -5px 5px rgba(69, 79, 99, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  .btn-left {
    width: 50%;
    height: 40px;
    background: #ff510093;
    opacity: 1;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 20px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn-right {
    width: 50%;
    height: 40px;
    background: #ff5000;
    opacity: 1;

    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 20px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.click:active {
  transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
}
.btnC:active {
  background-color: rgba(255, 80, 0, 0.7) !important;
}
.pop-ordinal-block {
  text-align: left;
}
</style>
